import React, { useEffect, useRef } from "react";
import MessageBubble from "./MessageBubble";
import MentiBot from "../../images/menti.png";

interface ChatMessage {
    type: "user" | "bot" | string;
    text: string;
}

interface Props {
    messages: ChatMessage[];
    onSuggestionClick?: (suggestion: string) => void;
}

export default function ChatMessages({ messages, onSuggestionClick }: Props) {
    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({
            behavior: "smooth",
        });
    }, [messages]);

    if (messages.length === 0) {
        return (
            <div className="chat-empty">

                <div className="empty-icon">
                     <img src={MentiBot} alt="Menti AI" width="120"/>
                </div>

                {/* <h2>Menti</h2> */}

                <p>
                    Ask any question about your course.
                </p>

                <div className="suggestion-grid">

                    <div className="suggestion-card" onClick={() => onSuggestionClick?.("Explain today's chapter")}>
                        Explain today's chapter
                    </div>

                    <div className="suggestion-card" onClick={() => onSuggestionClick?.("Generate 5 MCQs")}>
                        Generate 5 MCQs
                    </div>

                    <div className="suggestion-card" onClick={() => onSuggestionClick?.("Give me important questions")}>
                        Give me important questions
                    </div>

                    <div className="suggestion-card" onClick={() => onSuggestionClick?.("Summarize this topic")}>
                        Summarize this topic
                    </div>

                </div>

            </div>
        );
    }

    return (

        <div className="chat-messages">

            {messages.map((message, index) => (

                <MessageBubble
                    key={index}
                    type={message.type}
                    text={message.text}
                />

            ))}

            <div ref={bottomRef}></div>

        </div>

    );

}